import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { idResponseSchema } from './id-response';

export type AddCashdeskMutationParams = {
	currency: string;
	accountId: number;
	name: string;
	cashierIds?: number[];
	note: string;
};

export const createAddCashdeskMutation = () =>
	createAuthMutation({
		params: declareParams<AddCashdeskMutationParams>(),
		request: {
			method: 'POST',
			url: '/cashdesk',
			body: (data) => data,
		},
		response: {
			contract: zodContract(idResponseSchema),
		},
	});
